import { useMemo } from 'react';
export const DOTS = '...';
export const range = (start, end) => {
  const range = [];
  for (let i = start; i <= end; i++) {
    range.push(i);
  }
  return range;
};
export const defaultPageSizeOptions = [10, 20, 30, 50];
export const getPageSizeOptions = pageSizeOptions => {
  return pageSizeOptions.map(pageSize => ({
    label: pageSize.toString(),
    value: pageSize.toString()
  }));
};
export const usePageSizeSelectOptions = pageSizeOptions => useMemo(() => getPageSizeOptions(pageSizeOptions), [pageSizeOptions]);